import React from 'react'
import { useNavigate } from 'react-router-dom'

import Paper from '@mui/material/Paper'

import { useCommand } from '~/client/hooks/cqrpc'
import useStateObject from '~/client/hooks/useStateObject'
import Heading from '~/client/components/Heading'
import Heading from '~/client/components/Heading.js'
import AppForm from '../AppForm.js'

export default function Page() {
  return <Paper sx={{margin: 'auto', mt: 2, p: 2}}>
    <Heading variant="sub" sx={{mb: 2}}>Register a new App</Heading>
    <NewAppForm />
  </Paper>
}

function NewAppForm() {
  const navigate = useNavigate()
  const [value, onChange] = useStateObject({
    name: '',
    homepageUrl: '',
    description: '',
    callbackUrl: '',
  })
  const cmd = useCommand('apps.create', {
    onSuccess(app){
      navigate(`/settings/apps/${app.host}`);
    },
  })
  return <AppForm {...{
    submitText: ['Register App', 'Registering App…'],
    onSubmit(){ cmd.call(value) },
    submitting: cmd.pending,
    submittable: !!(
      value.name &&
      value.homepageUrl &&
      value.description &&
      value.callbackUrl
    ),
    error: cmd.error,
    value,
    onChange,
  }}/>
}
